import { SDrawerOrModal } from 'shj-components'
import styles from './index.module.less'
import HorizontalScrollGallery from '../HorizontalScrollGallery'
import KitDetailDialogV3 from '../KitDetailDialogV3'
import ModifyStandard from '../modifyStandard'
import { useEffect, useRef, useState } from 'react'
import { additionSearchPage, listProductSkuRelationSpuFormat } from '@/services/order'
import { Button, message, Spin, Tooltip, Image } from 'antd'
import star from '@/assets/star.png'
import starFullfill from '@/assets/star-fullfill.png'

import { numFormat } from 'shj-components/dist/es/SFilterTable'
import {
  favoritesAdd,
  favoritesDelete,
  favoritesList,
  selectProductSpuDetail,
} from '@/services/goodsFrontendTenant'
import { cloneDeep, isArray } from 'lodash-es'
import { CopyOutlined, RightOutlined } from '@ant-design/icons'
import SkuDynamicContent from '../SkuDynamicContent'

export default function FollowModal(props: any) {
  const { open, onClose, onSubmit, record, showGoodsDetail, fetchParams, changeProductInfo } = props
  const [data, setData] = useState<any>({})
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  // 套件明细
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [productInfo, setProductInfo] = useState<any>({})
  const [followed, setFollowed] = useState(false)
  const [currentSrc, setCurrentSrc] = useState(undefined)
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false)
  const [modifyCurrentSku, setModifyCurrentSku] = useState<any>({})
  const [followedSkuList, setFollowedSkuList] = useState<any[]>([])
  const [combinationPrice, setCombinationPrice] = useState(undefined)
  const [skuDynamicContentOpen, setSkuDynamicContentOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const kitDetailRef = useRef<any>(null)
  useEffect(() => {
    console.log(record, 'record')
    let newProductInfo = cloneDeep(record)
    // 如果有套件明细数据，过滤调不显示的数据 然后显示
    if (newProductInfo.productSpu?.combinationInfo?.length > 1) {
      newProductInfo.productSpu.combinationInfo = newProductInfo.productSpu?.combinationInfo.filter(
        item => item.allowView
      )
      // 打开套件明细弹窗
      handleKitDetail(newProductInfo)
    }
    if (newProductInfo.productSpu?.skuSize > 1) {
      // 多规格
      handleEditDynamicProperties(newProductInfo)
    }
    if (newProductInfo.productSku?.extField1?.length) {
      // 报价属性
      setSkuDynamicContentOpen(true)
    }
    setProductInfo({ ...newProductInfo })
    findFollowedSku()
  }, [])
  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, index?: any) => {
    console.log(record, index)
    console.log(fetchParams)

    setModifyStandardOpen(true)
    let resData
    try {
      setLoading(true)
      resData = await selectProductSpuDetail({
        productSpuId: record.productSpu?.id,
        filterOrgId: fetchParams?.filterOrgId || null,
      })
      setLoading(false)
    } catch {
      setLoading(false)
    }
    setSkuList(resData?.productSpu?.skuList)
    resData?.productSpu?.specificationArgList?.map((item: any) => {
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData?.productSpu?.specificationArgList || [])
  }
  useEffect(() => {
    if (modifyCurrentSku && modifyCurrentSku.id) {
      if (!followedSkuList?.length) {
        setFollowed(false)
        return
      }
      if (followedSkuList?.find(item => item.targetId === modifyCurrentSku.id)) {
        setFollowed(true)
      } else {
        setFollowed(false)
      }
    } else {
    }
  }, [modifyCurrentSku])
  const findFollowedSku = async () => {
    try {
      // setLoading(true)
      const followRes: any = await favoritesList({
        type: 'SKU',
        targetIds: record?.productSpu?.skuList?.map(item => item.id),
      })

      if (isArray(followRes) && followRes.length) {
        // 非多规格 只看当前产品Sku
        if (!modifyStandardOpen) {
          if (followRes?.find(item => item.targetId === record?.productSku?.id)) {
            setFollowed(true)
          } else {
            setFollowed(false)
          }
        }
        setFollowedSkuList(followRes)
      }
      // setLoading(false)
    } catch (error) {
      // setLoading(false)
    }
  }
  const handleToFollow = () => {
    // kitDetailRef?.current?.confirmDialog()
    // 判断是否有多sku
    console.log(modifyCurrentSku)
    let targetId: any = productInfo?.productSku?.id
    let type: any = 'SKU'
    if (modifyCurrentSku && modifyCurrentSku.id) {
      targetId = modifyCurrentSku.id
      type = 'SKU'
    }
    setBtnLoading(true)
    favoritesAdd({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        setFollowed(true)
        findFollowedSku()
        record.favorite = {
          targetId: targetId,
        }
        changeProductInfo(record)
        message.success('收藏成功')
      })
      .catch(err => {
        // message.error('收藏失败')
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }
  const handleToCancelFollow = () => {
    let targetId: any = productInfo?.productSku?.id
    let type: any = 'SKU'
    if (modifyCurrentSku && modifyCurrentSku.id) {
      targetId = modifyCurrentSku.id
      type = 'SKU'
    }
    setBtnLoading(true)
    favoritesDelete({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        setFollowed(false)
        findFollowedSku()
        record.favorite = null
        changeProductInfo(record)
        message.success('取消成功')
      })
      .catch(err => {
        // message.error('取消失败')
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }
  const priceHandle = price => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    }
  }
  const clickToChangeMainPic = val => {
    console.log(val)
    setCurrentSrc(val)
  }

  const handleKitDetail = async (record: any) => {
    setLoading(true)
    setKitSku(record?.productSpu?.skuList?.[0])
    setKitSpu(record?.productSpu)
    setOpenKitDialog(true)
    setLoading(false)
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const clickToGoodsDetail = item => {
    // window.open(`/productDetail?spuId=${record?.productSpu?.id}`)
    window.open(
      `/order/materialSelectionLibrary/materialDetail/${item?.productSpu?.id}${fetchParams.filterOrgId ? `/${fetchParams.filterOrgId}` : ''}${fetchParams.filterGoodsId ? `/${fetchParams.filterGoodsId}` : ''}`,
      '_blank'
    )
  }
  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      onCancel={() => onClose()}
      width={920}
      title={'选择商品规格'}
      antdProps={{
        footer: null,
      }}
    >
      <Spin spinning={loading}>
        <div className={styles.followModalBox}>
          <div className={styles.leftBox}>
            <div className={styles.imgBox}>
              {/* <img src={currentSrc ? currentSrc : productInfo?.productSpu?.mainPicUrl} alt="" /> */}
              <Image
                src={currentSrc ? currentSrc : productInfo?.productSpu?.mainPicUrl}
              />
            </div>
            <div className={styles.imgListBox}>
              <HorizontalScrollGallery
                items={productInfo?.productSpu?.imageUrls}
                onlyImg={true}
                imgWidth={70}
                getValue={clickToChangeMainPic}
              ></HorizontalScrollGallery>
            </div>
          </div>
          <div className={styles.rightBox}>
            {/* 产品明细 */}
            <div className={styles.commodityBox}>
              <div className={styles.commodityInfo}>
                <div className={styles.commodityName}>
                  {/* {showNationalTagRender()} */}
                  <Tooltip
                    title={productInfo?.productSpuName || productInfo?.productSpu?.prodName}
                    placement="topLeft"
                  >
                    <p> {productInfo?.productSpuName || productInfo?.productSpu?.prodName}</p>
                  </Tooltip>
                </div>
                <p className={styles.spuBox}>
                  <span>SPU：</span>
                  {productInfo?.productSpu?.id}
                  <CopyOutlined
                    style={{ marginLeft: '8px' }}
                    className="copyIcon"
                    onClick={() => {
                      clickToCopy(productInfo?.productSpu?.id)
                    }}
                  />
                </p>
                {showGoodsDetail && (
                  <div
                    className={styles.goodsDetailBtn}
                    onClick={() => clickToGoodsDetail(productInfo)}
                  >
                    <span>查看商品详情</span> <RightOutlined />
                  </div>
                )}
              </div>
            </div>
            <div className={styles.middleBox}>
              {openKitDialog && (
                <KitDetailDialogV3
                  kitSku={kitSku}
                  setKitSku={setKitSku}
                  getCombinationPrice={setCombinationPrice}
                  productInfo={kitSpu}
                  combinationInfoList={combinationInfoList}
                  activityInfo={activityInfo}
                  checkType="RightConfigArea"
                  ref={kitDetailRef}
                  filterOrgId={fetchParams.filterOrgId}
                />
              )}
              {/* 修改规格 */}
              {modifyStandardOpen && (
                <ModifyStandard
                  formList={currentModifyStandardArray}
                  currentSku={modifyCurrentSku}
                  setCurrentSku={setModifyCurrentSku}
                  skuList={skuList}
                ></ModifyStandard>
              )}
              {/* 动态属性 */}
              {skuDynamicContentOpen && (
                <SkuDynamicContent
                  loading={false}
                  formList={productInfo?.productSku?.extField1}
                  // onSubmit={onSubmitSkuDynamicVoList}
                  // currentItem={kit}
                ></SkuDynamicContent>
              )}
            </div>

            <div className={styles.footerBox}>
              <div className={styles.priceBox}>
                <span className={styles.priceBoxSmall}>￥</span>
                {(modifyCurrentSku?.priceInfo?.customerPrice ?? 0) ? (
                  priceHandle(modifyCurrentSku?.priceInfo?.customerPrice)
                ) : (combinationPrice ?? 0) ? (
                  priceHandle(combinationPrice)
                ) : productInfo?.minCustomerPrice ? (
                  <>
                    {priceHandle(productInfo?.minCustomerPrice)}
                    {productInfo?.customerPriceList.length > 1 && (
                      <span className={styles.priceBoxStart}>起</span>
                    )}
                  </>
                ) : (
                  '--'
                )}
              </div>
              <div>
                {followed ? (
                  <Button
                    type="primary"
                    loading={btnLoading}
                    className={styles.followBtn}
                    onClick={handleToCancelFollow}
                  >
                    取消收藏 <img src={starFullfill} alt="" />
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    loading={btnLoading}
                    className={styles.followBtn}
                    onClick={handleToFollow}
                  >
                    加入收藏 <img src={star} alt="" />
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </SDrawerOrModal>
  )
}
